import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export enum LegacyMushroomContentType {
    UNKNOWN_ASSET_TYPE = 0,
    GENERIC_LARGE_ASSET_TYPE = 1,
    GENERIC_SMALL_ASSET_TYPE = 2,
    AD_REMOTE_ASSET = 3,
    AD_SNAP = 4,
    AD_WEB_VIEW_RESOURCE_CONTENT = 5,
    ATTACHMENT_INFO = 6,
    BITMOJI = 7,
    BITMOJI_LENS_AVATAR_ASSET = 8,
    BITMOJI_LENS_METADATA = 9,
    CAPTION_METADATA = 10,
    CAPTION_TYPEFACE = 11,
    CAPTION_VIEW_BITMAP = 12,
    CHAT_MEDIA_THUMBNAIL = 13,
    COGNAC = 14,
    COGNAC_WEBVIEW = 15,
    COMMERCE = 16,
    CONTEXT_FILTER_METADATA = 17,
    CUSTOM_STICKERS = 18,
    DISCOVER_FEED_THUMBNAIL = 19,
    DISCOVER_PUBLISHER_SNAP = 20,
    DISCOVER_STORY_SNAP = 21,
    DISCOVER_STORY_STREAMING_SNAP = 22,
    EMOJI = 23,
    EMOJI_BRUSH = 24,
    EXTERNAL_GEOFILTER = 25,
    EXTERNAL_STICKER = 26,
    GEOFILTER_OVERLAY = 27,
    IMAGELOADING_URL = 28,
    HELVETICA = 29,
    INFO_STICKER = 30,
    LENS_CONTENT = 31,
    LENS_ICON = 32,
    LENS_OVERLAY_IMAGE = 33,
    LENS_REMOTE_ASSET = 34,
    LOGIN_KIT_PRIVACT = 35,
    MAPS_EGGHUNT = 36,
    MAPS_KASHMIR = 37,
    MAPS_WORLDEFFECTS = 38,
    MEDIA_PACKAGE_COMPOSITE = 39,
    MEDIA_PACKAGE_THUMB = 40,
    MEMORIES_EDITS = 41,
    MEMORIES_MEDIA = 42,
    MEMORIES_MINI_THUMBNAIL = 43,
    MEMORIES_OVERLAY = 44,
    MEMORIES_THUMBNAIL = 45,
    NON_USER_BITMOJI = 46,
    PAYMENTS = 47,
    PUBLISHER_SNAP_MEDIA = 48,
    SHAZAM = 49,
    SKY_MODEL = 50,
    SNAP = 51,
    SNAP_FIRST_FRAME = 52,
    SNAP_LOADING_FRAME = 53,
    SNAP_STICKER = 54,
    SPECTACLES = 55,
    STICKER_TAG = 56,
    STICKERS_METADATA = 57,
    STORY_SNAP = 58,
    STORY_THUMB = 59,
    TRACKING_DATA = 60,
    USER_GENERATED_ASSETS = 61,
    UNRECOGNIZED = -1
}
export interface ContentManagerSignals {
    legacyMushroomContentType: LegacyMushroomContentType;
}
function createBaseContentManagerSignals(): ContentManagerSignals {
    return { legacyMushroomContentType: 0 };
}
export const ContentManagerSignals: MessageFns<ContentManagerSignals> = {
    encode(message: ContentManagerSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.legacyMushroomContentType !== 0) {
            writer.uint32(8).int32(message.legacyMushroomContentType);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): ContentManagerSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContentManagerSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.legacyMushroomContentType = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<ContentManagerSignals>, I>>(base?: I): ContentManagerSignals {
        return ContentManagerSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<ContentManagerSignals>, I>>(object: I): ContentManagerSignals {
        const message = createBaseContentManagerSignals();
        message.legacyMushroomContentType = object.legacyMushroomContentType ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
